import clsx from 'clsx';
import { LuPlay, LuFastForward } from 'react-icons/lu';
import { RoundButton, RoundButtonProps } from './RoundButton';

interface RoundPlayButtonProps extends RoundButtonProps {
  isFastForward?: boolean;
}

export const RoundPlayButton = ({
  size = 'md',
  isFastForward = false,
  ...props
}: RoundPlayButtonProps) => (
  <RoundButton size={size} {...props}>
    {isFastForward ? (
      <LuFastForward
        className={clsx(
          size === 'sm' && 'text-4xl',
          size === 'md' && 'text-6xl',
          size === 'lg' && 'text-8xl',
        )}
      />
    ) : (
      <LuPlay
        className={clsx(
          size === 'sm' && 'text-4xl',
          size === 'md' && 'text-6xl',
          size === 'lg' && 'text-8xl',
        )}
      />
    )}
  </RoundButton>
);
